import React from 'react';

const LeadPositionPatternMob = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" width="100%" height="100%" viewBox="0 0 429 791" fill="none">
      <circle opacity="0.18" cx="409.5" cy="25.5" r="13.5" fill="#DDCAEB" stroke="#7F4A9B" stroke-width="10" />
      <circle opacity="0.35" cx="376" cy="63" r="12" fill="#DDCAEB" />
      <circle opacity="0.35" cx="98.2195" cy="506.951" r="11.2195" fill="#DDCAEB" />
      <circle opacity="0.35" cx="144.78" cy="477.22" r="11.2195" fill="#DDCAEB" />
      <path opacity="0.29" d="M0 206.686C142.659 264.867 202.984 101.716 132.469 33.3627L99.454 0H0V206.686Z" fill="#A971C7" />
      <path opacity="0.2" d="M0 80.7087C85.1346 179.352 219.964 105.166 202.449 0H0V80.7087Z" fill="#7F4A9B" />
      <path opacity="0.2" d="M428.404 739.814C372.314 677.36 283.482 724.329 295.022 790.913L428.404 790.913L428.404 739.814Z" fill="#7F4A9B" />
      <path opacity="0.29" d="M428.404 659.811C334.473 622.906 294.754 726.394 341.182 769.75L362.921 790.913L428.404 790.913L428.404 659.811Z" fill="#A971C7" />
    </svg>
  );
};

export default LeadPositionPatternMob;